module.exports = __webpack_public_path__ + "static/media/wave.8c48ef20.svg";